import { Params } from '@angular/router';
import { IgMedia } from '@core/models/ApiFields/ig-entities';
import { IData, ReqMode } from '@core/models/IApi';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { TableState } from '@features/social-analysis/social-shared/store/table.store';
import { TableHttpBuilder } from '../../social-shared/services/http/table-simple-http';
import { tagsMentionsFields } from '../config/tags-mentions.config';

export class TagsMentionsHttpBuilder extends TableHttpBuilder {
    protected buildParams(
        { limit, offset, sorting, hiddenSort }: TableState<IData>,
        pageFilters: PageFiltersState,
        mode: ReqMode
    ): Params {
        const dates = this.getDates(pageFilters.selectedDates());
        return {
            ...dates,
            fields: this.getFields(),
            limit: limit(),
            offset: offset(),
            sort: this.formatSorting(sorting(), hiddenSort),
            mode: mode,
            ...this.formatFilters(pageFilters.appliedFilters()),
            ...this.getMediaTypeFilter(),
        };
    }

    private getFields(): string {
        return tagsMentionsFields.join();
    }

    private getMediaTypeFilter() {
        return { [IgMedia.getPrefixed('mediaType')]: 'eq:tag' };
    }
}
